<template>
    <el-table :data="tableData" style="width: 100%" border size="mini" stripe>
        <el-table-column prop="name" label="" width="96" align="right" fixed></el-table-column>
        <el-table-column :prop="val" :label="`${val}:00`" align="center" v-for="(val,index) in columns" :key="index"></el-table-column>
    </el-table>
</template>

<script>
    import { formatDate, getBeltInfo, getPetInfoByDevice, getSignal4G, getEphemerisMeta, getSimCardInfo, getHistoryTrack, getHistoryMotion, getDeviceConnectState } from '../api'
    export default {
        name: 'TimeData',
        props: {
            history_date: {
                type: String,
                default: ''
            }
        },
        data () {
            return {
                curr_date: '',
                history_motion: {},
                signal_4g: {}
            }
        },
        computed: {
            columns () {
                let len = this.curr_date === this.history_date ? (new Date()).getHours() : 24
                let _columns = []
                for (let m = len; m >= 0; m--) {
                    _columns.push(`${m.toString().padStart(2, '0')}`)
                }
                return _columns
            },
            tableData () {
                let _data = []
                let _mObj = {
                    name: '当天运动'
                }
                let _bObj = {
                    name: '当天电量'
                }
                let _gObj = {
                    name: '4G信号'
                }
                let _history_motion = this.history_motion || {}
                let _signal_4g = this.signal_4g || {}
                for (let m = 0; m < this.columns.length; m++) {
                    let _key = Number(this.columns[m])
                    if (_history_motion[_key] !== undefined) {
                        _mObj[this.columns[m]] = _history_motion[_key][3]
                        _bObj[this.columns[m]] = _history_motion[_key][4]
                    } else {
                        _mObj[this.columns[m]] = ''
                        _bObj[this.columns[m]] = ''
                    }
                    if (_signal_4g[_key] !== undefined) {
                        _gObj[this.columns[m]] = _signal_4g[_key]
                    } else {
                        _gObj[this.columns[m]] = ''
                    }
                }
                _data.push(_mObj)
                _data.push(_bObj)
                _data.push(_gObj)
                return _data
            }
        },
        watch: {
            history_date () {
                this.initData()
            }
        },
        methods: {
            initData () {
                const qSC = this.$route.query['sc'];
                getHistoryMotion(qSC, this.history_date).then(
                    res => {
                        this.history_motion = res.data.data[0] || {}
                    },
                    err => {
                        this.history_motion = {}
                    }
                )
                getSignal4G(qSC, this.history_date).then(
                    res => {
                        this.signal_4g = res.data.data || {}
                    },
                    err => {
                        this.signal_4g = {}
                    }
                )
            }
        },
        mounted () {
            let currentTime = new Date()
            let year = currentTime.getFullYear()
            let month = currentTime.getMonth()
            month = month + 1 < 10 ? '0' + (month + 1) : month + 1
            let day = currentTime.getDate()
            day = day < 10 ? '0' + day : day
            this.curr_date = year + '-' + month + '-' + day
            this.initData()
        }
    }
</script>
